export default {
  SUCCESS_MESSAGE: 'Filial cadastrada com sucesso!',
};
